var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTincture = function SvgTincture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.57 26.52",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.08,
    width: 12.35,
    height: 4.1,
    rx: 0.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 7.48h-.05V3.27a3.27 3.27 0 0 0-6.54 0v4.21h-.05A.78.78 0 0 0 18.88 9h6.82a.78.78 0 0 0 .18-1.55.54.54 0 0 0-.18.03ZM20.05 10.58v11a3.24 3.24 0 0 0 1.78 3.17v1c0 .43.25.77.55.77.3 0 .55-.34.56-.77v-1a3.25 3.25 0 0 0 1.77-3.17v-11ZM13.66 7.37h-.06V5.65H2.91v1.72h-.06A2.87 2.87 0 0 0 0 10.22v13.41a2.87 2.87 0 0 0 2.85 2.85h10.81a2.87 2.87 0 0 0 2.85-2.85V10.22a2.87 2.87 0 0 0-2.85-2.85ZM8.25 20.8a3.66 3.66 0 0 1-3.6-3.6A5 5 0 0 1 6 14.26l2.29-2.93 2.3 2.93a5 5 0 0 1 1.31 2.94 3.61 3.61 0 0 1-3.62 3.6Z"
  })));
};
export default SvgTincture;